import React, { useContext } from 'react';
import styled from 'styled-components';
import { CounterContext } from 'context/bestContext';
import { ThemeContext } from 'context/themeContext';
import Name from './components/name';
import Items from './components/items';
import Space from './components/items';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 120;
  opacity: ${(props) => (props.open ? '1' : '0')};
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  /* background-color: rgba(0,0,0,0.8); */
  transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out;
`;

const CloseWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 120;
  display: ${(props) => (props.open ? 'block' : 'none')};
`;

const SettingWrapper = styled.div`
  position: absolute;
  top: 3.435vw;
  direction: ${(props) => (props.rtlDirection ? 'rtl' : 'ltr')};
  right: ${(props) => (props.rtlDirection ? 'unset' : '1.04vw')};
  left: ${(props) => (props.rtlDirection ? '1.04vw' : 'unset')};
  width: ${(props) => (props.open ? '16.137vw' : '0')};
  height: ${(props) => (props.open ? '23.113vw' : '0')};
  border: 1px solid ${(props) => props.theme.borderBackground};
  border-radius: 1.04vw;
  border-top-right-radius: ${(props) => (props.rtlDirection ? '1.04vw' : '0')};
  border-top-left-radius: ${(props) => (props.rtlDirection ? '0' : '1.04vw')};
  overflow: hidden;
  z-index: 121;
  background-color: ${(props) => props.theme.cardBackground};
  box-shadow: ${(props) =>
    props.open ? '0 0 15px 1px rgb(94,95,98,0.3)' : '0 0 15px 1px rgb(94,95,98,0)'};
  transition: 200ms ease-in-out;

  /* Tablet Responsive styles */
  @media (max-width: 768px) {
    transform: scale(2.5);
    transform-origin: top left;
    top: 8vw;
    right: 26vw;
  }

  /* Mobile Responsive styles */
  @media (max-width: 480px) {
    transform: scale(4);
    transform-origin: top left; /* Ensure scaling starts from a specific point */
    transition: transform 0.3s ease-in-out; /* Optional for smooth scaling */
    top: 12vw;
    right: 53vw;
  }
`;

function Sidebar() {
  const { rtlDirection, theme } = useContext(ThemeContext);
  const { showSetting, setShowSetting } = useContext(CounterContext);
  return (
    <Wrapper open={showSetting}>
      <CloseWrapper open={showSetting} onClick={() => setShowSetting(false)} />
      <SettingWrapper rtlDirection={rtlDirection} open={showSetting} theme={theme}>
        <Name />
        <Items setShowSetting={setShowSetting} />
      </SettingWrapper>
    </Wrapper>
  );
}

export default React.memo(Sidebar);
